export const liveIndicatorStyle = {
  backgroundColor: '#2D8285',
  color: 'white',
  borderRadius: 20,
  fontSize: '16px',
  fontWeight: 'bold',
  padding: '5px 12px',
  marginTop: -20,
  marginLeft: 25,
  verticalAlign: 'middle',
  cursor: 'default'
};

export const containerStyle = {
  marginBottom: 20,
  padding: 10,
  borderRadius: 8,
  border: `1px solid #ECF0F1`,
  backgroundColor: 'white'
};
